"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhone = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconPhone = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.5 14c-1.657-1.974-3.154-4.31-2.329-5.003.144-.12 2.33-2.378 2.33-2.378L8.18 4.046c-.529-1.033-1.496-2.564-1.496-2.564s-2.517 1.29-3.266 1.92c-.728.61-.455 2.948.416 5.3.711 1.922 2.02 4.236 4.03 6.633 2.012 2.396 4.064 4.087 5.833 5.122 2.165 1.265 4.42 1.94 5.148 1.33.749-.63 2.457-2.884 2.457-2.884s-1.34-1.218-2.265-1.92l-2.305-1.744s-2.603 1.76-2.747 1.88c-.825.692-2.83-1.145-4.486-3.119Z"
}));
exports.IconPhone = IconPhone;
//# sourceMappingURL=IconPhone.js.map